import { supabase, getCurrentUser } from './supabase';
import { normalizeWorkoutWheelConfig } from './workoutWheelConfig';
import type { WorkoutWheelConfig } from '../types';

export async function fetchWorkoutWheelConfig(): Promise<WorkoutWheelConfig | null> {
  const user = await getCurrentUser();
  if (!user) throw new Error('User not authenticated');

  const { data, error } = await supabase
    .from('workout_wheel_config')
    .select('config')
    .eq('user_id', user.id)
    .maybeSingle();

  if (error) throw error;
  if (!data?.config) return null;
  return normalizeWorkoutWheelConfig(data.config);
}

export async function upsertWorkoutWheelConfig(config: WorkoutWheelConfig): Promise<void> {
  const user = await getCurrentUser();
  if (!user) throw new Error('User not authenticated');

  const { error } = await supabase.from('workout_wheel_config').upsert(
    {
      user_id: user.id,
      config,
      updated_at: new Date().toISOString(),
    },
    { onConflict: 'user_id' }
  );
  if (error) throw error;
}
